var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinterest = function SvgPinterest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pinterest_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12c0 4.913 2.956 9.136 7.185 10.991-.035-.838-.007-1.844.208-2.756.231-.973 1.544-6.539 1.544-6.539s-.384-.766-.384-1.898c0-1.78 1.031-3.107 2.314-3.107 1.092 0 1.62.82 1.62 1.802 0 1.098-.7 2.739-1.06 4.259-.3 1.272.638 2.31 1.894 2.31 2.273 0 3.804-2.919 3.804-6.38 0-2.629-1.77-4.597-4.992-4.597-3.641 0-5.909 2.715-5.909 5.746 0 1.045.31 1.783.79 2.353.224.263.255.369.174.67-.056.22-.189.753-.244.963-.08.303-.326.412-.601.3-1.676-.685-2.457-2.521-2.457-4.584 0-3.41 2.873-7.497 8.575-7.497 4.582 0 7.598 3.316 7.598 6.875 0 4.707-2.618 8.223-6.476 8.223-1.295 0-2.513-.7-2.93-1.495 0 0-.698 2.764-.846 3.299-.252.924-.752 1.849-1.206 2.57 1.078.318 2.218.492 3.4.492C18.628 24 24 18.627 24 12c0-6.628-5.372-12-11.999-12C5.373 0 0 5.372 0 12Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pinterest_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgPinterest;